/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import {
  Box, Grid, makeStyles, LinearProgress,
} from '@material-ui/core';
import moment from 'moment';
import PropTypes from 'prop-types';
import {
  React, useEffect, useState,
} from 'react';
// import useIsDevicePermissionAllowed from '../../hooks/useIsDevicePermissionAllowed';
import { useProject } from '../../config/ProjectContext';
import GraphqlService from '../../service/graphqlService';
import PageBanner from '../../components/utils/PageBanner';
import SimpleAlert from '../../components/utils/SimpleAlert';
import DeviceSettingsTable from './MachineTelemetry/DeviceSettingsTable';
import { validate, calculateEndDateTimeIso, calculateStartDateTimeIso } from '../../utils/dateUtils';
import JSONBuilderFilters, { valueTypes } from '../../components/utils/JSONBuilderFilters';
// import FineGrainedPermissionsInfo from '../Admin/FineGrainedPermissions/FineGrainedPermissionsInfo';
import useAnalytics from '../../hooks/useAnalytics';

const useStyles = makeStyles((theme) => ({
  formField: {
    width: '100%',
    '& ::placeholder': {
      paddingLeft: 8,
      paddingTop: 8,
    },
  },
  formPlaceholder: {
    '&::placeholder': {
      textOverflow: 'ellipsis !important',
      color: 'blue',
    },
  },
  inputDescriptionLabel: {
    font: theme.typography.h4.font,
    color: theme.palette.primary.text,
  },
  contentInfo: {
    backgroundColor: theme.palette.background.default,
  },
  // tabs
  headerTabPanel: {
    backgroundColor: theme.palette.background.paper,
  },
  labelHeaderTabPanel: {
    color: theme.palette.primary.labelHeader,
    fontFamily: theme.typography.h3.fontFamily,
    fontSize: '14px',
    fontWeight: theme.typography.fontWeightMedium,
    letterSpacing: '0',
    lineHeight: '16px',
    textAlign: 'center',
    width: '720px',
    height: '48px',
  },
  detailsTitle: {
    paddingRight: '5px',
    fontFamily: theme.typography.h5.fontFamily,
    lineHeight: theme.typography.h5.lineHeight,
    letterSpacing: theme.typography.h5.letterSpacing,
    fontSize: theme.typography.h5.fontSize,
    color: theme.palette.primary.subMain,
  },
  accordion: {
    borderRadius: '12px !important',
  },
  details: {
    paddingLeft: 24,
    paddingRight: 24,
  },
}));

export default function DeviceSettings({ deviceSerial, triggerSettingsSearch }) {
  const jsonColumns = [
    {
      id: 'processed_on_utc', label: 'Platform Timestamp (UTC)', valueType: valueTypes.DATE, values: [],
    },
  ];

  const { setAnalytics } = useAnalytics();

  if (!deviceSerial) {
    jsonColumns.push({
      id: 'serial', label: 'Device Serial', valueType: valueTypes.STRING, values: [],
    });
  }
  const MAX_DAYS_BETWEEN_DATES = 31;
  const params = { add_dict: true };
  // STATE________________________________
  const { project } = useProject();

  // grid
  const [totalCount, setTotalCount] = useState(0);
  const [reducedPage, setReducedPage] = useState(0);
  const [, setPaginationTokens] = useState(['']);
  const [rowsPerPageConsumption] = useState(10);
  const [reducedResponse, setReducedResponse] = useState(null);

  //  alert data
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertHeader, setAlertHeader] = useState('');
  const [alertText, setAlertText] = useState('');

  //  state values
  const [loading, setLoading] = useState(false);

  // errors
  const [, setDateStartError] = useState(false);
  const [, setDateEndError] = useState(false);
  const [, setGreaterSmallerDateError] = useState(false);
  const [, setMoreThanMaxDaysDateError] = useState(false);

  // data
  const [selectedFilters, setSelectedFilters] = useState('');
  const [selectedStartDate, setSelectedStartDate] = useState(moment().add(-7, 'days'));
  const [selectedStartTime, setSelectedStartTime] = useState(moment().format('12:00'));
  const [selectedEndDate, setSelectedEndDate] = useState(moment());
  const [selectedEndTime, setSelectedEndTime] = useState(moment().format('23:59'));

  const [dateRangePickerVisibility, setDateRangePickerVisibility] = useState(true);

  const [filterError, setFilterError] = useState('');

  // const { isAllowed: isDeviceAllowed } = useIsDevicePermissionAllowed(deviceSerial);

  function openAlert(header, text) {
    setAlertHeader(header);
    setAlertText(text);
    setAlertOpen(true);
  }

  function addDeviceSerialAsFilter(filters) {
    if (!deviceSerial) {
      return filters;
    }
    const filtersParsed = JSON.parse(filters || '{ "filter": [] }');
    filtersParsed.filter.push({ column: 'serial', operator: 'EQ', value: deviceSerial });
    return JSON.stringify(filtersParsed);
  }

  // functions to obtain the data to show
  async function searchObject(myProject, filters, startDate, endDate, newPage) {
    // if (deviceSerial && !isDeviceAllowed) {
    //   openAlert('Error', 'You do not have permission to access this device');
    //   return [];
    // }
    setDateRangePickerVisibility(!dateRangePickerVisibility);
    const consumptionResponse = await GraphqlService.getTelemetryObject(
      myProject.code, 'snaps/devices', JSON.stringify(params), addDeviceSerialAsFilter(filters), startDate, endDate, rowsPerPageConsumption, (newPage || 0) * rowsPerPageConsumption, MAX_DAYS_BETWEEN_DATES,
    );
    // eslint-disable-next-line no-plusplus
    if (consumptionResponse) {
      if (totalCount < 1 || !newPage) {
        setTotalCount(consumptionResponse.pagination.totalRows);
      }
      return JSON.parse(consumptionResponse.data);
    }
    return [];
  }

  async function search(myProject, filters, startDate, endDate, startTime, endTime, newPage, newValue) {
    try {
      setLoading(true);

      setAnalytics({
        event: 'button_clicked',
        extraParams: {
          name: deviceSerial ? 'device_management-overview-telemetry-search-settings' : 'device_management-telemetry-search-settings'
        },
      });

      let creationResponse = [];

      setReducedPage(newPage || 0);
      creationResponse = await searchObject(myProject, filters, calculateStartDateTimeIso(startDate, startTime), calculateEndDateTimeIso(endDate, endTime), newPage);
      setPaginationTokens(['']);
      setReducedResponse(creationResponse);
      setMoreThanMaxDaysDateError(false);

      setLoading(false);
      return creationResponse;
    } catch (error) {
      setLoading(false);
      openAlert('Error', error.message);
      return null;
    }
  }

  const onSearch = (event, filters) => {
    event.preventDefault();
    if (validate(selectedStartDate, selectedEndDate, selectedStartTime, selectedEndTime, MAX_DAYS_BETWEEN_DATES, setDateStartError, setDateEndError, setSelectedStartDate, setSelectedStartTime, setSelectedEndDate, setSelectedEndTime, setGreaterSmallerDateError, setMoreThanMaxDaysDateError)) {
      search(
        project, filters, selectedStartDate, selectedEndDate, selectedStartTime, selectedEndTime,
      );
    }
  };

  // WEBPAGE______________________________
  const classes = useStyles();

  useEffect(() => {
    setPaginationTokens(['']);
  }, [selectedFilters, selectedStartDate, selectedEndDate]);

  // Effect to trigger search when parent component requests it
  useEffect(() => {
    if (
      deviceSerial
      // && isDeviceAllowed
      && validate(
        selectedStartDate, selectedEndDate, selectedStartTime, selectedEndTime,
        MAX_DAYS_BETWEEN_DATES, setDateStartError, setDateEndError,
        setSelectedStartDate, setSelectedStartTime, setSelectedEndDate,
        setSelectedEndTime, setGreaterSmallerDateError, setMoreThanMaxDaysDateError,
      )) {
      search(project, selectedFilters, selectedStartDate, selectedEndDate, selectedStartTime, selectedEndTime, 0);
    }
  }, [triggerSettingsSearch]);

  // Column mapping for renaming
  const columnMapping = {
    serial: 'Device Serial',
    processed_on_utc: 'Platform Timestamp (UTC)',
    'settings.0': 'Settings',
  };

  // Columns to hide
  const columnsToHide = ['received_first_on_utc', 'received_on_utc'];

  return (
    <Box spacing={0}>
      {loading && <LinearProgress />}
      <SimpleAlert open={alertOpen} setOpen={setAlertOpen} header={alertHeader} body={alertText} />
      {!deviceSerial && (
        <PageBanner title="DEVICE SETTINGS" />
      )}
      {/* <FineGrainedPermissionsInfo
        open={false}
        onClose={() => { }}
        style={{ margin: 24 }}
      /> */}
      <Grid
        container
        spacing={0}
      >
        <Grid item xs={12} className={classes.contentInfo}>
          <JSONBuilderFilters
            id="DeviceSettings"
            setSelectedFilters={setSelectedFilters}
            selectedStartDate={selectedStartDate}
            setSelectedStartDate={setSelectedStartDate}
            selectedStartTime={selectedStartTime}
            setSelectedStartTime={setSelectedStartTime}
            selectedEndDate={selectedEndDate}
            setSelectedEndDate={setSelectedEndDate}
            selectedEndTime={selectedEndTime}
            setSelectedEndTime={setSelectedEndTime}
            filtersVisible
            linkVisible
            deviceSerialVisible={false}
            jsonColumns={jsonColumns}
            setDateRangePickerVisibility={dateRangePickerVisibility}
            onSearch={onSearch}
            setFilterError={setFilterError}
            filterError={filterError}
          />
        </Grid>
        <Grid item xs={12}>
          <DeviceSettingsTable
            search={(newPage) => search(project, selectedFilters, selectedStartDate, selectedEndDate, selectedStartTime, selectedEndTime, newPage)}
            dataList={reducedResponse}
            totalCount={totalCount}
            filters={selectedFilters}
            loading={loading}
            dateIni={calculateStartDateTimeIso(selectedStartDate, selectedStartTime)}
            dateEnd={calculateEndDateTimeIso(selectedEndDate, selectedEndTime)}
            rangeDates={MAX_DAYS_BETWEEN_DATES}
            page={reducedPage}
            setPage={setReducedPage}
            rowsPerPage={rowsPerPageConsumption}
            object="snaps/devices"
            params={params}
            id="DeviceSettings"
            columnMapping={columnMapping}
            columnsToHide={columnsToHide}
            isOverview={deviceSerial !== undefined}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
DeviceSettings.propTypes = {
  deviceSerial: PropTypes.string.isRequired,
  triggerSettingsSearch: PropTypes.any,
};

DeviceSettings.defaultProps = {
  triggerSettingsSearch: null,
};
